export const capabilities = [
  {
    "short": "理解研究意图",
    "title": "理解研究意图，明确科学问题",
    "desc": "结合研究背景、已有材料和预期目标，与你共同梳理科学问题，明确比较对象与研究范围，形成后续研究的目标与要求。",
    "output": "研究目标与范围",
    "file": "研究目标.md",
    "question": "我有四个细胞系处理与未处理的 RNA-seq 数据，想看看地塞米松影响了哪些基因。",
    "response": "先确认每个细胞系的处理与未处理样本如何对应，再核对处理条件。分析将比较配对样本的基因表达变化。"
  },
  {
    "short": "判断数据可行性",
    "title": "评估数据质量与研究可行性",
    "desc": "检查样本分组、关键变量、缺失值和异常记录，评估数据对研究问题的支持程度，明确适用的分析方法与需要补充的信息。",
    "output": "数据检查与可行性说明",
    "file": "数据检查.csv",
    "question": "这八个样本能做配对分析吗？还需要补充哪些信息？",
    "response": "先核对样本表中的细胞系、处理条件与测序批次，确认四组配对关系，并检查数据质量和缺失信息。"
  },
  {
    "short": "梳理文献证据",
    "title": "综合文献证据，识别研究分歧",
    "desc": "检索并比较相关研究，梳理主要发现、方法差异与证据缺口，为研究假设和方案设计提供参考。保留原文来源，便于核查与引用。",
    "output": "文献综述与证据整理",
    "file": "文献证据.md",
    "question": "已有研究如何解释气道平滑肌细胞对地塞米松的响应？",
    "response": "按研究对象、处理条件和实验方法整理相关文献，列出已有发现与不同解释，并附上原文来源。"
  },
  {
    "short": "制定研究方案",
    "title": "设计研究方案与验证策略",
    "desc": "结合文献证据与数据条件，共同推敲研究假设、方法选择和验证策略。比较备选方案，评估潜在偏倚，制定研究设计与分析计划。",
    "output": "研究设计与分析计划",
    "file": "研究设计.md",
    "question": "如何在分析中考虑不同细胞系本身的表达差异？",
    "response": "可以采用包含细胞系和处理条件的配对设计。先检查设计是否可估计，再约定差异基因筛选阈值和后续验证办法。"
  },
  {
    "short": "分析与科学制图",
    "title": "专业数据分析与科学可视化",
    "desc": "按方案执行统计分析与计算，检查方法适用条件，并按需要补充验证。整理结果表，生成专业的科研图表。",
    "output": "分析代码、结果表与科研图表",
    "file": "差异表达分析.svg",
    "question": "按配对设计做差异表达分析，画出火山图并标注筛选阈值。",
    "response": "分析时考虑细胞系差异，比较地塞米松处理与未处理样本。结果表保留倍数变化和校正后 P 值，供核对火山图。"
  },
  {
    "short": "深入解读结果",
    "title": "解读研究结果，提出验证方向",
    "desc": "结合研究设计与文献证据，比较结果的不同解释，分析它们对原有假设的支持与限制。对阴性或意外结果进一步检查数据与方法，提出后续验证方向。",
    "output": "结果解释与后续验证建议",
    "file": "结果讨论.md",
    "question": "有些基因的变化与预期不同，应该先检查什么？",
    "response": "先核对这些基因的表达量、样本间差异和统计结果，再对照相关实验条件与文献，讨论是否需要补充验证。"
  },
  {
    "short": "独立审查修正",
    "title": "严格的对抗式审查机制",
    "desc": "独立的 AI 审查者对研究假设、分析方法与结论提出质疑，检查证据缺口和其他可能的解释。针对关键问题提出修正或补充验证要求，并保留审查意见与修改记录。",
    "output": "审查意见与修改记录",
    "file": "分析审核.md",
    "question": "请独立检查配对设计、筛选阈值，以及结果解释是否超出证据。",
    "response": "重点核查样本配对、模型设计和多重检验校正。将需要修正的分析问题与尚待实验验证的解释分别列出。"
  },
  {
    "short": "研究写作",
    "title": "科研写作与科学论证",
    "desc": "依据实际研究结果组织论证，起草论文、报告与汇报材料，阐释发现及其意义。核对数字、图表与引用，并与你共同完善讨论和研究局限。",
    "output": "论文草稿、报告与汇报材料",
    "file": "研究报告.md",
    "question": "根据分析结果起草论文的结果与讨论部分，注明还需要验证的解释。",
    "response": "先描述表达变化和统计结果，再结合文献讨论可能的解释。核对正文、图表和引用，并说明样本与实验条件的限制。"
  },
  {
    "short": "交付与复现",
    "title": "成果交付与研究过程追溯",
    "desc": "整理报告、图表、代码、参数与环境说明，保存对应的数据版本和修订记录，为成果核查与重复执行提供材料。补充数据或回应审稿意见时，可据此追溯分析过程。",
    "output": "成果文件与分析材料",
    "file": "研究交付/",
    "question": "整理报告、图表和代码，保留重新运行与复核需要的材料。",
    "response": "将成果与对应的数据版本、参数和环境说明一起整理，并列出已完成的工作、研究限制和待解决问题。"
  }
];
export const faqs=[
 ['Sciland™ 适合什么研究？','Sciland™ 支持文献调研、研究设计、数据分析、计算研究和成果写作。生物医学是当前重点优化的领域；具体可执行范围取决于数据条件、所需工具与计算资源。'],
 ['需要下载客户端吗？','需要。Sciland™ 以桌面客户端为主，官网提供下载、注册与账户入口。支持 macOS Apple 芯片与 Windows 64 位。请在下载页选择对应系统的安装包。'],
 ['一定要从研究设计开始吗？','不需要。你可以从一个问题、一组数据或已有研究材料开始。讨论、调研、分析、审查和写作会根据研究进展交叉进行。'],
 ['Chat 和 Research 如何选择？','临时问答、资料整理和相对独立的任务可以使用 Chat。需要围绕课题持续推进时，使用 Research 与 AI 共同制定方案、开展分析并讨论结果。确认后的摘要和附件可从 Chat 交接为新的 Research。'],
 ['我能在研究过程中调整方向吗？','可以。你可以补充背景与证据、提出要求、调整方向或停止任务。研究设计和待办也可以随着新发现更新。'],
 ['研究数据和结果如何管理？','项目文件和运行环境主要在本机，模型与账户功能依赖在线服务。分析材料和交付文件支持查看与追溯；研究结果仍需结合领域知识审阅和验证。'],
];
export type CaseStudy={id:string;field:string;title:string;desc:string;tags:string[];outputs:string;steps:string[];cover?:{src:string;alt:string}};
// Provide an approved cover here: cover:{src:'/cases/your-cover.webp',alt:'Description of the research cover'}.
export const cases:CaseStudy[]=[
 {id:'bxb1-integrase-mutation-prediction',field:'生命科学',title:'Bxb1 整合酶单点突变计算预测',desc:'用进化打分、结构稳定性与保守性三方共识，筛选可能提高重组效率的单点突变。',tags:['蛋白质工程','结构计算','独立审核'],outputs:'候选排序表 · 结构图 · 分析代码',steps:['获取 Bxb1 结构与同源序列，确认催化与 DNA 识别位点','用 ESM 进化打分与 ProteinMPNN 结构打分分别评估突变','结合保守性排除破坏关键功能的位置','汇总三方共识排序，交付候选与结构可视化'],cover:{src:'/cases/bxb1-integrase-mutation-prediction.webp',alt:'Bxb1 整合酶与 DNA 复合体的三维结构'}},
 {id:'qm9-isomer-structure-property',field:'材料与化学',title:'C₇H₁₀O₂ 同分异构体结构—性质分析',desc:'在分子式固定的前提下，分析连接方式如何影响自由能、能隙、偶极矩与极化率。',tags:['数据分析','量子化学','机器学习'],outputs:'性质对比表 · 帕累托前沿 · 分析代码',steps:['从 QM9 中筛出 C₇H₁₀O₂ 同分异构体并核对数据质量','提取环结构、支化、官能团等二维结构特征','比较各结构特征对四项性质的解释力','求解多目标帕累托前沿并归纳共有结构特点'],cover:{src:'/cases/qm9-isomer-structure-property.webp',alt:'同分异构体结构式与性质对比热图'}},
 {id:'jarvis-dft-2d-material-screening',field:'材料与化学',title:'JARVIS-DFT 二维材料多目标筛选',desc:'检验剥离能、形成能与带隙三项目标是否必然取舍，并找出同时满足三者的材料。',tags:['材料筛选','多目标优化','数据检查'],outputs:'候选材料表 · 帕累托图 · 分析记录',steps:['导入 NIST JARVIS-DFT 二维材料数据并检查缺失','分析剥离能、形成能与带隙之间的相关性','按三项目标区间筛选候选材料','整理帕累托前沿与候选清单'],cover:{src:'/cases/jarvis-dft-2d-material-screening.webp',alt:'二维材料多目标筛选的帕累托前沿散点图'}},
];
export const routes:Record<string,{title:string;desc:string}>={
 '/':{title:'Sciland™｜AI 原生科研工作空间',desc:'Sciland™ 是来自 Isoplex Intelligence 的 AI 原生科研工作空间，为人与 AI 共同探索科学问题而构建。围绕假设、证据与研究判断展开协作。支持 macOS 与 Windows。'},
 '/features':{title:'产品功能｜Sciland™ AI 原生科研工作空间',desc:'了解 Sciland™ 的九项研究能力，涵盖文献调研、研究设计、专业分析与科学制图、对抗式审查、科研写作及成果交付。'},
 '/cases':{title:'研究示例｜Sciland™',desc:'按学科和研究方法浏览 Sciland™ 研究任务示例，了解关键问题、分析思路与预期成果。'},
 '/guides':{title:'使用指南｜Sciland™',desc:'从下载客户端、准备研究材料到开始 Chat 或 Research，了解 Sciland™ 的使用方法。'},
 '/scenarios':{title:'应用场景｜Sciland™',desc:'从探索新课题、分析已有数据到整理研究成果，找到适合你的 Sciland™ 使用方式。'},
 '/enterprise':{title:'合作机会｜Sciland™',desc:'围绕团队的真实研究任务，交流数据、工具和计算环境需求，讨论 Sciland™ 的适用范围与合作方式。'},
 '/about':{title:'关于 Isoplex 壹索智能｜科学发现基础设施',desc:'Isoplex 壹索智能开发 Sciland™ AI 原生科研工作空间，并开展科学世界模型与实验协同技术研发，致力于构建下一代科学发现基础设施。'},
 '/login':{title:'登录 / 注册｜Sciland™',desc:'使用手机号验证码、密码或微信登录 Sciland™。新手机号通过验证码登录时自动注册。'},
 '/terms':{title:'服务条款｜Sciland™',desc:'Sciland™ 服务条款。'},
 '/privacy':{title:'隐私政策｜Sciland™',desc:'Sciland™ 隐私政策与个人信息处理说明。'},
 '/account':{title:'个人中心｜Sciland™',desc:'查看研值余额与使用明细，设置账号资料和登录密码。'},
 '/redeem':{title:'兑换研值｜Sciland™',desc:'使用活动兑换码领取 Sciland™ 研值。'},
 '/download':{title:'下载客户端｜Sciland™',desc:'下载 Sciland™ 桌面客户端。获取 macOS Apple 芯片版与 Windows 64 位版安装包，查看安装指南。'},
};
